module.exports = __webpack_public_path__ + "92ca484b3569bc45c61c25f81930ab16.svg";